export { default as PaymentTermsAgree } from './payment-terms-agree'
